module.exports = __webpack_public_path__ + "img/service3.d008a703.png";